import React from 'react';
import ReactDOM from 'react-dom';
import superagent from 'superagent';

import { LoggedUserName, LoggedUserId, LoggedUserAdmin } from '../login/Login';

import styles from './Home.css';

function AddZero(value) {
  return ("0" + value).slice(-2);
}

function GetNyni(d) {
  return d.getFullYear() + '-' + AddZero(d.getMonth()+1) + '-' + AddZero(d.getDate()) + ' ' + AddZero(d.getHours()) + ':' + AddZero(d.getMinutes());
}

function InfoMsg(prop) {
  if (prop.text == '') {
    return null;
  }
  return (
    <div className={"alert alert-" + prop.style} role="alert">
      {prop.text}
    </div>
  )
}

function PrihlaseniLide(prop) {
  if (prop.lide == null) {
    return (<div className="col-9 col-sm-10"></div>);
  }
  if (prop.lide.length == 0) {
    return (<div className="col-9 col-sm-10"><i>nikdo není přihlášen</i></div>);
  }
  var poradi = 0;
  var lidiEl = prop.lide.map((clovek) => {
    poradi++;
    return (
      <div key={poradi}>
        {poradi}. {clovek.jmeno}
      </div>
    )
  });

  return (
    <div className="col-9 col-sm-10">
      {lidiEl}
    </div>
  )
}


class LekceInfo extends React.Component {

  constructor() {
    super();
    this.state = {
      message: '',
      messageStyle: '',
      lide: null,
    };

    this.handleClickZrusitRezervaci = this.handleClickZrusitRezervaci.bind(this);
  }

  handleClickZrusitRezervaci() {
    event.preventDefault();

    superagent.post('https://rezervace.copasedeje.cz/servis/_rezervace.php').
      send("userid="+LoggedUserId()).
      send("stav=ODHLASENI").
      send("lekceid="+this.props.lekce.id).
      then(res => {
        var myObject = JSON.parse(res.text);
        if (myObject.error == '') {
          this.props.addKredit(1);
          this.props.loadLekce();
        } else {

        }
      });
    return false;
  }

  render() {
    var d = new Date();
    var nyni = GetNyni(d);
    var zacatek = this.props.lekce.date + ' ' + this.props.lekce.cas_od;
    var rezervaceDisabled = (1*this.props.lekce.pocet >= 1*this.props.lekce.kapacita) || (nyni > zacatek);  // prihlasit se nemuzu pokud je plno nebo uz byl zacatek
    d.setHours(d.getHours() + 12);  // posunu cas nyni o 12 hodin
    var nyni12 = GetNyni(d);
    var zruseniRezervaceDisabled = (nyni12 > zacatek);  // zrusit rezervaci mohu, pokud cas nyni posunuty o 12 hodin je stale driv nez zacatek

    let messageStyle = '';
    let message = '';
    let pocetStyle = '';

    if (this.props.lekce.aktivni == 'N') {
      messageStyle = 'secondary'
      message = 'Lekce byla zrušena'
    } else if (nyni > zacatek) {
      messageStyle = 'secondary'
      message = 'Lekce již proběhla'
    } else {
      if (1*this.props.lekce.pocet >= 1*this.props.lekce.kapacita) {
        pocetStyle = 'table-danger'
      } else {
        pocetStyle = 'table-success'
      }
      if (this.props.lekce.prihlasen == 'A') {
        if (nyni12 > zacatek) {
          messageStyle = 'success'
          message = 'Rezervaci již není možné zrušit'
        }
      } else {
        if (1*this.props.lekce.pocet >= 1*this.props.lekce.kapacita) {
          messageStyle = 'danger'
          message = 'Lekce je již plně obsazena'
        }
      }
    }
    return (
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title text-danger" id="exampleModalCenterTitle">{this.props.lekce.nazev}</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <InfoMsg style={messageStyle} text={message}/>
          <div className="row pt-1 pb-1"><div className="col-3 col-sm-2">Datum:</div><div className="col-9 col-sm-10">{this.props.lekce.datum}</div></div>
          <div className="row pt-1 pb-1"><div className="col-3 col-sm-2">Čas:</div><div className="col-9 col-sm-10">{this.props.lekce.cas_od}-{this.props.lekce.cas_do}</div></div>
          <div className="row pt-1 pb-1"><div className="col-3 col-sm-2">Instruktor:</div><div className="col-9 col-sm-10">{this.props.lekce.lektor}</div></div>
          <div className="row pt-1 pb-1"><div className="col-3 col-sm-2">Obsazenost:</div><div className="col-9 col-sm-10"><span className={pocetStyle + " pl-2 pr-2 pb-1 pt-1 pointer"} onClick={this.props.handleClickSeznamLidi}>{this.props.lekce.pocet} / {this.props.lekce.kapacita}</span></div></div>
          <div className="row pt-1 pb-1"><div className="col-3 col-sm-2">Popis:</div><div className="col-9 col-sm-10">{this.props.lekce.popis}</div></div>
          {LoggedUserAdmin() ?
            (
              <div className="row pt-1 pb-1">
                <div className="col-3 col-sm-2">Přihlášení:</div>
                  <PrihlaseniLide lide={this.props.lide} />
              </div>
            ) : (
              null
            )}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Zavřít</button>
          {((this.props.lekce.prihlasen == 'A') && (this.props.lekce.aktivni == 'A')) ?
            (<button type="button" className="btn btn-danger" data-dismiss="modal" disabled={zruseniRezervaceDisabled} onClick={this.handleClickZrusitRezervaci}>Zrušit rezervaci</button>) : null
          }
          {((this.props.lekce.prihlasen != 'A') && (this.props.lekce.aktivni == 'A')) ?
            (<button type="button" className="btn btn-success" disabled={rezervaceDisabled} onClick={this.props.handleClickRezervovat}>Rezervovat</button>) : null
          }
        </div>
      </div>
    )
  }
}

class UserInfo extends React.Component {

  constructor() {
    super();
    this.state = {
      user: null,
    }
  }

  componentWillMount = () => {
    var responseObj = superagent.get('https://rezervace.copasedeje.cz/servis/_user_info.php?userid=' + LoggedUserId() + '&t=' + Date()).set('Content-Type', 'application/json').then(response => {
      var myObject = JSON.parse(response.text);
      this.setState({user: myObject});
    });
  }

  render() {
    let messageStyle = '';
    let message = '';
    //let pocetStyle = '';
    var lekce = '';
    var lekceStr = '';
    //pocetStyle = '';
    if (this.state.user != null) {
      lekce = this.state.user.lekce;
      if (lekce == null) {
        lekce = '';
      }
      switch(lekce) {
        case '':
          lekceStr = 'nemáte žádný kredit'
          //pocetStyle = 'table-danger'
          break;
        case '1':
          lekceStr = ' lekce'
          break;
        case '2':
          lekceStr = ' lekce'
          break;
        case '3':
          lekceStr = ' lekce'
          break;
        case '4':
          lekceStr = ' lekce'
          break;
        default:
          lekceStr = ' lekcí'
          break;
      }
    }

    return (
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title text-danger" id="exampleModalCenterTitle">Potvrzení rezervace</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <InfoMsg style={messageStyle} text={message}/>
          <div className="row pt-1 pb-1"><div className="col-2">Lekce:</div><div className="col-10">{this.props.lekce.nazev}</div></div>
          <div className="row pt-1 pb-1"><div className="col-2">Datum:</div><div className="col-10">{this.props.lekce.datum}</div></div>
          <div className="row pt-1 pb-1"><div className="col-2">Čas:</div><div className="col-10">{this.props.lekce.cas_od}-{this.props.lekce.cas_do}</div></div>
          <hr className="row" />
          <div className="row pt-1 pb-1"><div className="col-2">Uživatel:</div><div className="col-10">{LoggedUserName()}</div></div>
          <div className="row pt-1 pb-1"><div className="col-2">Kredit:</div><div className="col-10">{lekce + lekceStr}</div></div>
          <div className="row pt-1 pb-1">
            <div className="col-2"></div>
            <div className="col-10">
              <input className="" type="checkbox" disabled={lekce <= 1} ref="inputHost" id="inputHost" onChange={this.props.setPocet} /> <label className={"form-check-label " + styles.checkBoxLabel} htmlFor="inputHost">+ 1 host</label>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Zavřít</button>
          <button type="button" className="btn btn-success" data-dismiss="modal" disabled={(lekce == '' || lekce <= 0)} onClick={this.props.handleRezervovat}>Rezervovat</button>
        </div>
      </div>
    )
  }
}

class LekceLidi extends React.Component {

  constructor() {
    super();
    this.state = {
      lidi: null,
    }
  }

  componentWillMount = () => {
    var responseObj = superagent.get('https://rezervace.copasedeje.cz/servis/_lekce_lidi.php?userid=' + LoggedUserId() + '&lekce_id=' + this.props.lekce.id + '&t=' + Date()).set('Content-Type', 'application/json').then(response => {
      var myObject = JSON.parse(response.text);
      this.setState({lidi: myObject});
    });
  }

  render() {
    if (this.state.lidi == null) {
      return (
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-danger" id="exampleModalCenterTitle">Seznam přihlášených</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">

          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-dismiss="modal">Zavřít</button>
            <button type="button" className="btn btn-success" onClick={this.props.handleClickLekceInfo}>Zpět</button>
          </div>
        </div>
      )
    }

    if (this.state.lidi.length == 0) {
      return (
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-danger" id="exampleModalCenterTitle">Seznam přihlášených</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <i>Nikdo není přihlášen</i>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-dismiss="modal">Zavřít</button>
            <button type="button" className="btn btn-success" onClick={this.props.handleClickLekceInfo}>Zpět</button>
          </div>
        </div>
      )
    }

    var poradi = 0;
    var lidiEl = this.state.lidi.map((lidi) => {
      poradi++;
      return (
        <div key={lidi.id_user}>
          {poradi}. {lidi.jmeno}
        </div>
      )
    });


    return (
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title text-danger" id="exampleModalCenterTitle">Seznam přihlášených</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row pt-1 pb-1"><div className="col-3 col-sm-2">Datum:</div><div className="col-9 col-sm-10">{this.props.lekce.datum}</div></div>
          <div className="row pt-1 pb-1"><div className="col-3 col-sm-2">Čas:</div><div className="col-9 col-sm-10">{this.props.lekce.cas_od}-{this.props.lekce.cas_do}</div></div>
          <div className="row pt-1 pb-1">
            <div className="col-3 col-sm-2">Přihlášení:</div>
            <div className="col-9 col-sm-10">
              {lidiEl}
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Zavřít</button>
          <button type="button" className="btn btn-success" onClick={this.props.handleClickLekceInfo}>Zpět</button>
        </div>
      </div>
    )
  }
}

export default class KalendarModalInfo extends React.Component {

  constructor() {
    super();
    this.state = {
      coZobrazit: 'LekceInfo',
      lide: null,
      pocet: 1,
    };
    this.handleClickLekceInfo = this.handleClickLekceInfo.bind(this);
    this.handleClickRezervovat = this.handleClickRezervovat.bind(this);
    this.handleClickSeznamLidi = this.handleClickSeznamLidi.bind(this);
    this.setPocet = this.setPocet.bind(this);
    this.handleRezervovat = this.handleRezervovat.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({coZobrazit: 'LekceInfo', lide: null});
    if (nextProps.lekce != null) {
      var responseObj = superagent.get('https://rezervace.copasedeje.cz/servis/_lekce_lidi.php?userid=' + LoggedUserId() + '&lekce_id=' + nextProps.lekce.id + '&t=' + Date()).set('Content-Type', 'application/json').then(response => {
        var myObject = JSON.parse(response.text);
        this.setState({lide: myObject});
      });
    }
  }

  handleClickLekceInfo() {
    this.setState({coZobrazit: 'LekceInfo'});
  }

  handleClickRezervovat() {
    this.setState({coZobrazit: 'UserInfo'});
  }

  handleClickSeznamLidi() {
    //this.setState({coZobrazit: 'LekceLidi'});
  }

  setPocet(e) {
    if (e.target.checked) { var pocet = 2 } else { var pocet = 1 }
    this.setState({pocet: pocet});
  }

  handleRezervovat(event) {
    event.preventDefault();
    superagent.post('https://rezervace.copasedeje.cz/servis/_rezervace.php').
      send("userid="+LoggedUserId()).
      send("stav=REZERVACE").
      send("lekceid="+this.props.lekce.id).
      send("pocet="+this.state.pocet).
      then(res => {
        var myObject = JSON.parse(res.text);
        if (myObject.error == '') {
          this.props.addKredit(-1);
          this.props.loadLekce();
        } else {

        }
      });

    return false;
  }

  render() {
    if (this.props.lekce == null)
      return null;

    return (
      <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">

          {this.state.coZobrazit == 'LekceInfo' ?
            (
              <div className="modal-dialog modal-dialog-centered" role="document">
                <LekceInfo lekce={this.props.lekce} lide={this.state.lide}  handleClickRezervovat={this.handleClickRezervovat} handleClickSeznamLidi={this.handleClickSeznamLidi} loadLekce={this.props.loadLekce} addKredit={this.props.addKredit} />
              </div>
            ) : (
              <div className="modal-dialog modal-dialog-centered" role="document">
                {this.state.coZobrazit == 'UserInfo' ?
                  (
                    <UserInfo lekce={this.props.lekce} handleRezervovat={this.handleRezervovat} addKredit={this.props.addKredit} setPocet={this.setPocet} />
                  ) : (
                    <LekceLidi lekce={this.props.lekce} handleClickLekceInfo={this.handleClickLekceInfo} />
                  )
                }
              </div>
            )
          }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/kalendar/KalendarModalInfo.js